<template>
    <div>
        <div class="col-md-12">
            <div class="panel panel-visible" id="spy2">

                <loading :active.sync="isLoading" color="#4c4a49" :is-full-page="false"></loading>
                <vue-cal
                    locale="ru"
                    active-view="day"
                    hide-view-selector
                    :time-step="30"
                    :time-from="7 * 60"
                    :time-to="23 * 60"
                    sticky-split-labels
                    :split-days="this.calendar.rooms"
                    :events="this.calendar.events"
                    :dblclickToNavigate="false"
                    :disable-views="['years', 'year', 'month']"
                    :editable-events="true"
                    :watchRealTime="false"
                    :overlapsPerTimeStep="false"
                    :on-event-click="eventShowEdit"
                    @cell-dblclick="eventShowAdd($event)"
                    class="vuecal--full-height-delete"
                    @event-delete="eventDelete($event)"
                    @event-change="eventChangeTime($event)"
                    @view-change="updateEventsList($event)"
                    @event-drop="eventDrop($event)"
                >
                    <template v-slot:event="{ event, view }">
                        <div class="vuecal__event_wrapper"  :class="{'vuecal__event_active': event.id === selectedEvent.id}">
                            <div class="vuecal__event-title">{{event.title}}</div>
                            <div
                                    v-if="event.trainer"
                                    class="vuecal__event-trainer"
                                    :title="event.replace ? `Заменяет: ${event.replace.trainerOld.fullName}` : ''"
                            >
                                {{event.trainer.fullName}}
                                <i v-if="event.replace" class="glyphicon glyphicon-share-alt"></i>
                            </div>
                            <div class="vueval__event-fill">{{event.fill}} из {{event.capacity}}</div>
                        </div>
                    </template>
                </vue-cal>
            </div>
        </div>
        <right-sidebar
            title="Добавление события"
            :show="forms.add.isShow"
            :is-loading="forms.add.isLoading"
        >
            <template v-slot:content>
                <form class="ng-pristine ng-valid" @submit.prevent="eventAdd">
                    <div class="panel-body">
                        <div class="mb10">
                            <span class="label label-info">
                                {{selectedEvent.start | dateFormat('dd.mm.yyyy')}}
                                с <strong>{{selectedEvent.start | dateFormat('HH:MM')}}</strong>
                                по <strong>{{selectedEvent.end | dateFormat('HH:MM')}}</strong>
                            </span>
                        </div>

                        <div class="form-group">
                            <label class="field-label">Инструктор</label>
                            <vue-select
                                :clearable="false"
                                :options="trainers"
                                v-model="selectedEvent.trainerId"
                                :searchable="true"
                                :reduce="trainer => trainer.id"
                                :get-option-label="getTrainerFullName"
                            />
                        </div>
                        <div class="form-group">
                            <label class="field-label">Направление</label>
                            <vue-select
                                :clearable="false"
                                :options="directions"
                                v-model="selectedEvent.directionId"
                                :searchable="true"
                                :reduce="direction => direction.id"
                                :get-option-label="option => option.name"
                            />
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" v-model="rooms.find(room => selectedEvent.fitnessRoomId === room.id).name" name="room_show" disabled>
                        </div>
                        <div class="form-group">
                            <input type="text" class="form-control" v-model="selectedEvent.capacity" placeholder="Вместимость">
                        </div>

                    </div>
                    <div class="panel-menu">
                        <button type="submit" class="btn btn-success btn-xs mr10">Сохранить</button>
                        <button type="button" class="btn btn-xs btn-danger" @click.prevent="eventAddClose">Отмена</button>
                    </div>
                </form>
            </template>
        </right-sidebar>

        <right-sidebar title="Редактировать событие" :show="forms.edit.isShow">
            <template v-slot:content>
                <form @submit.prevent="eventEdit" class="panel">
                    <div class="panel-body">
                        <div class="form-group">
                            <label class="field-label">Инструктор</label>
                            <select class="form-control input-sm" v-model="selectedEvent.trainerId">
                                <option v-for="trainer in trainers" v-bind:key="'trainer-edit-' + trainer.id" :value="trainer.id">
                                    {{trainer.firstName}}
                                    {{trainer.lastName}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="field-label">Направление</label>
                            <select class="form-control input-sm" v-model="selectedEvent.directionId">
                                <option v-for="direction in directions" v-bind:key="'direction-edit-' + direction.id" :value="direction.id">
                                    {{direction.name}}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="field-label">Причина замены</label>
                            <select class="form-control input-sm" v-model="forms.edit.reasonChange" required>
                                <option v-for="reason in reasons" v-bind:key="'reason-edit-' + reason.id" :value="reason.id">
                                    {{reason.name}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="panel-menu">
                        <button type="submit" class="btn btn-xs btn-success mr10">
                            Сохранить
                        </button>
                        <button type="button" class="btn btn-xs btn-danger close_sidebar_right" @click.prevent="eventEditClose">Отмена</button>
                    </div>
                </form>

                <div class="panel" v-if="selectedEvent.replace">
                    <div class="panel-heading">
                        <span class="panel-icon">
                            <i class="glyphicon glyphicon-list-alt"></i>
                        </span>
                        <span class="panel-title">Замена</span>
                    </div>
                    <div class="panel-body">

                        <span><del>{{selectedEvent.replace.trainerOld.fullName}}</del></span>
                        =>
                        <span>{{selectedEvent.trainer.fullName}}</span>

                    </div>

                </div>

                <div class="panel">
                    <div class="panel-heading">
                        <span class="panel-icon">
                            <i class="glyphicon glyphicon-list-alt"></i>
                        </span>
                        <span class="panel-title">Список клиентов</span>
                    </div>
                    <div class="panel-body">

                        <div class="bs-component">
                            <table class="table">
                                <tbody>
                                <tr v-for="(visit, index) in selectedEventVisits" v-bind:key="index">
                                    <td>{{index + 1}}</td>
                                    <td>
                                        <router-link :to="{name: 'clients-edit', params: {id: visit.client.id}}" target="_blank">
                                            {{visit.client.fullName}}
                                        </router-link>
                                        <span v-if="visit.isReservation">
                                            (резерв)
                                        </span>
                                    </td>
                                    <td>
                                        <drop-down-button classes="btn-info btn-xs">
                                            <li>
                                                <a v-on:click="removeVisit(visit)">
                                                    Удалить
                                                </a>
                                            </li>
                                        </drop-down-button>
                                    </td>
                                </tr>
                                <tr v-if="selectedEventVisits.length === 0">
                                    <td class="text-center">Нет записей</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                </div>

                <div class="panel">
                    <div class="panel-heading">
                        <span class="panel-title"><span>{{selectedEvent.updated.login}} @ {{selectedEvent.updated.date | dateFormatTimestamp('dd.mm.yyyy HH:MM:ss')}}</span></span>
                    </div>
                </div>

                <div class="panel" id="remove_schedule_item">
                    <div class="panel-heading">
                        <span class="panel-title">Удаление</span>
                    </div>
                    <div class="panel-menu">
                        <div class="form-group">
                            <button type="button" class="btn btn-warning mr10" @click.prevent="eventDelete({id: selectedEvent.id})">
                                Удалить занятие
                            </button>
                        </div>
                    </div>
                </div>
            </template>
        </right-sidebar>
    </div>
</template>

<script>
    import 'vue-cal/dist/i18n/ru';
    import FitnessRoom from "../../models/FitnessRoom";
    import Trainer from "../../models/Trainer";
    import Direction from "../../models/Direction";
    import Event from "../../models/Event";
    import dateFormat from 'dateformat';
    import Visit from "../../models/Visit";
    import 'vue-cal/dist/drag-and-drop.js';

    export default {
        components: {
            VueSelect: () => import('vue-select'),
            Loading: () => import('vue-loading-overlay'),
            VueCal: () => import('vue-cal'),
            RightSidebar: () => import('../RightSidebar'),
            dropDownButton: () => import('../data/DropDownButton'),
        },
        created() {
            this.calendar.filiationId = this.$route.params.id;
            this.load();
        },
        beforeRouteUpdate(to, from, next) {
            next();
            this.forms.add.isShow = false;
            this.forms.edit.isShow = false;
            this.calendar.filiationId = to.params.id;
            this.load();
        },
        data() {
            return {
                isLoading: false,
                trainers: [],
                directions: [],
                rooms: [],
                events: [],
                reasons: [
                    {id: 1, name: 'Отпуск'},
                    {id: 2, name: 'Личная причина'},
                ],
                calendar: {
                    filiationId: 0,
                    events: [],
                    rooms: [],
                },
                selectedEvent: new Event({visits: []}),
                selectedEventVisits: [],
                forms: {
                    add: {
                        isLoading: false,
                        isShow: false,
                    },
                    edit: {
                        isLoading: false,
                        isShow: false,
                        reasonChange: 0,
                    },
                },
            };
        },
        watch: {
            events: {
                handler: function() {
                    this.calendar.events = this.events.map(event => {
                        return {
                            id: event.id,
                            split: event.fitnessRoomId,
                            title: this.directions.find(direction => direction.id === event.directionId).name,
                            start: event.start,
                            end: event.end,
                            trainer: event.trainer,
                            replace: event.replace,
                            fill: event.fill,
                            capacity: event.capacity,
                        };
                    });
                },
                deep: true,
            },
            rooms: function() {
                this.calendar.rooms = this.rooms.map(room => {
                    return {
                        id: room.id,
                        label: room.name,
                        class: '',
                    };
                });
            },
        },
        methods: {
            getTrainerFullName(option) {
                if (typeof option === 'object') {
                    return option.fullName;
                }
                return option;
            },
            async load() {
                this.isLoading = true;

                let roomsResponse, directionsResponse, trainersResponse;
                [roomsResponse, directionsResponse, trainersResponse] = await Promise.all([
                    FitnessRoom.getList(1, 999, this.calendar.filiationId),
                    Direction.getList(1, 999),
                    Trainer.getList(1, 999, 'first_name'),
                ]);
                this.rooms = roomsResponse.data;
                this.directions = directionsResponse.data;
                this.trainers = trainersResponse.data;

                await this.getEventsByDate(new Date());

                this.isLoading = false;
            },
            eventShowAdd(event) {
                if (event.date === null) {
                    return;
                }
                this.eventEditClose();
                const roomId = Number(event.split);
                let room = this.rooms.find(room => room.id === roomId);
                if (!room) {
                    return;
                }

                let selectDate = this.roundMinutes(event.date);
                selectDate.setMilliseconds(3600000); // Добавляем час
                this.forms.add.end = new Date(selectDate);

                this.selectedEvent = new Event({
                    filiationId: this.calendar.filiationId,
                    fitnessRoomId: room.id,
                    trainerId: this.trainers[0].id,
                    directionId: this.directions[0].id,
                    start: this.roundMinutes(event.date),
                    end: new Date(selectDate),
                    capacity: room.capacity,
                });

                this.forms.add.isShow = true;
            },
            eventAdd() {
                this.isLoading = true;
                this.forms.add.isLoading = true;

                this.selectedEvent.add().then(newEvent => {
                    this.events.push(newEvent);

                    this.isLoading = false;
                    this.forms.add.isLoading = false;
                    this.eventAddClose();
                });
            },
            async eventShowEdit(event) {
                this.eventAddClose();

                this.selectedEvent = this.events.find(ev => ev.id === event.id);

                this.selectedEventVisits = [];
                const visits = await Visit.getListBySchedule(this.selectedEvent.id);
                this.selectedEventVisits = visits;

                this.forms.edit.isShow = true;
            },
            eventEdit() {
                this.isLoading = true;
                this.forms.edit.isLoading = true;

                this.selectedEvent.update(this.forms.edit.reasonChange).then((data) => {

                    let index = this.events.findIndex(ev => ev.id === this.selectedEvent.id);

                    this.events.splice(index, 1);
                    this.events.push(new Event(Event.toResponse(data.schedule)));

                    this.selectedEvent = new Event({visits: []});

                    this.isLoading = false;
                    this.forms.edit.isLoading = false;
                    this.eventEditClose();
                });
            },
            eventDrop(event) {
                let realEvent = this.events.find(ev => ev.id === event.event.id);
                realEvent.start = this.roundMinutes(event.event.start, true);
                realEvent.end = this.roundMinutes(event.event.end, true);
                realEvent.fitnessRoomId = event.event.split;

                realEvent.update();
            },
            eventAddClose() {
                this.forms.add.isShow = false;
            },
            eventEditClose() {
                this.forms.edit.isShow = false;
            },
            eventChangeTime(event) {
                let realEvent = this.events.find(ev => ev.id === event.event.id);
                realEvent.end = this.roundMinutes(event.event.end, true);

                realEvent.update();
            },
            async eventDelete(event) {
                this.eventEditClose();

                const isRemove = await this.events.find(ev => ev.id === event.id).remove();
                if (isRemove === true) {
                    const index = this.events.findIndex(ev => ev.id === event.id);
                    if (index >= 0) {
                        this.events.splice(index, 1);
                    }
                }
            },
            async getEventsByDate(startDate, endDate) {
                this.events = await Event.getListByDay(
                    this.calendar.filiationId,
                    dateFormat(startDate, 'yyyy-mm-dd'),
                    dateFormat(endDate, 'yyyy-mm-dd'),
                );
            },
            updateEventsList($event) {
                this.isLoading = true;
                this.eventAddClose();
                this.eventEditClose();
                if ($event.view === 'day') {
                    this.getEventsByDate($event.startDate, $event.startDate);
                } else {
                    this.getEventsByDate($event.startDate, $event.endDate);
                }
                this.isLoading = false;
            },
            roundMinutes(date, useRound = false) {
                const r = 1000 * 60 * 30;
                if (useRound === false) {
                    return new Date(Math.floor(date.getTime() / r) * r);
                } else {
                    return new Date(Math.round(date.getTime() / r) * r);
                }
            },
            async removeVisit(visit) {
                await visit.remove();
                const index = this.selectedEventVisits.findIndex(row => row.id === visit.id);
                if (visit.isReservation === 0) {
                    this.calendar.events.find(row => row.id === this.selectedEvent.id).fill--;
                }
                this.selectedEventVisits.splice(index, 1);
            },
        },
        metaInfo() {
            return {
                title: 'Расписание - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
